import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const validationApi = createApi({
  reducerPath: "validationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/is/validation",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Validation"],
  endpoints: (build) => ({
    getValidation: build.query({
      query: (id) => `${id}`,
      providesTags: ["Validation"],
    }),
  }),
});

export const {
  useGetValidationQuery,
} = validationApi;
